import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PlaceSelectionContainer from '../../containers/PlaceSelectionContainer';

const PlaceSelectionPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const previousPlace = location.state?.previousPlace;
    const formData = location.state?.formData;

    const handlePlaceSelect = (place) => {
        // 선택된 장소 정보와 기존 폼 데이터를 state로 전달하면서 뒤로 이동
        navigate('/app/create-meeting', {
            state: {
                selectedPlace: place,
                formData: formData ? {
                    ...formData,
                    imageUrl: formData.imageUrl // S3 URL도 함께 전달
                } : undefined
            }
        });
    };

    const handleBack = () => {
        // 이전 장소 정보와 기존 폼 데이터를 그대로 유지
        navigate('/app/create-meeting', {
            state: {
                selectedPlace: previousPlace,
                formData: formData ? {
                    ...formData,
                    imageUrl: formData.imageUrl
                } : undefined
            }
        });
    };

    return (
        <PlaceSelectionContainer
            title="장소 선택"
            onPlaceSelect={handlePlaceSelect}
            onBack={handleBack}
            previousPlace={previousPlace}
        />
    );
};

export default PlaceSelectionPage;
